import { ExternalCalendar, ID } from '@griply/types';
import { useQueries } from '@tanstack/react-query';
import { useMemo } from 'react';
import { getExternalConnectionCalendars } from 'shared/services/backend-api';

import { queryKey } from './use-external-connection-calendars-query';

export type ConnectionCalendar = ExternalCalendar & { connectionId: ID };

export const useExternalConnectionsCalendarsQueries = (connectionIds: ID[]) => {
  const queries = useQueries({
    queries: connectionIds.map((id) => ({
      queryKey: [queryKey, id],
      queryFn: () => getExternalConnectionCalendars(id),
      staleTime: 5 * 60 * 1000,
    })),
  });

  const calendars = useMemo(
    () =>
      queries.flatMap((query, index) =>
        (query.data ?? []).map((calendar) => ({
          ...calendar,
          connectionId: connectionIds[index],
        })),
      ),
    [queries, connectionIds],
  );

  return {
    calendars,
    isPending: queries.some((query) => query.isPending),
  };
};
